import { cn } from "@/lib/utils";
import type { InputKeyT } from "@patient-watch/types";
import { SimpleEntryValueSwitch } from "../SimpleEntryValueSwitch";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface RepeatableGroupEntryValueProps extends Omit<BaseEntryValueProps, "value"> {
    value: string | null;
    jsonValue?: Array<
        Array<{
            input_label: string;
            input_id: string;
            input_key: InputKeyT;
            value: string | number | boolean | string[] | Date | null;
        }>
    >;
}

export function RepeatableGroupEntryValue({
    value: _value,
    inputLabel,
    jsonValue = [],
    size,
    ...props
}: RepeatableGroupEntryValueProps) {
    if (!jsonValue.length) return null;

    return (
        <BaseEntryValue inputLabel={inputLabel} size={size} {...props}>
            <div className={cn("gap-4 grid mt-2", size === "sm" && "gap-2 mt-1", size === "lg" && "gap-6 mt-3")}>
                {jsonValue.map((group, index) => {
                    const groupKey = group[0]?.input_id || `group-${index}`;

                    return (
                        <div key={groupKey} className="pl-4 border-slate-200 border-l-2">
                            {group.map((groupValue) => (
                                <SimpleEntryValueSwitch
                                    value={groupValue.value}
                                    key={groupValue.input_key}
                                    inputKey={groupValue.input_key}
                                    inputLabel={groupValue.input_label}
                                    inputId={groupValue.input_id}
                                    size={size}
                                />
                            ))}
                        </div>
                    );
                })}
            </div>
        </BaseEntryValue>
    );
}
